const MODAL_SIZE = {
  BIG: 'big',
  NORMAL: 'normal',
};

export { MODAL_SIZE };
